if (!customElements.get('d50-review-showcase')) {
  class D50ReviewShowcase extends HTMLElement {
    connectedCallback() {
      this.slider = this.querySelector('[data-review-slider]');
      if (!this.slider || this.swiper) return;

      this.initBound = this.initSwiper.bind(this);
      this.blockSelectBound = this.handleBlockSelect.bind(this);
      document.addEventListener('shopify:block:select', this.blockSelectBound);
      if (window.Swiper) this.initSwiper();
      else window.addEventListener('load', this.initBound, { once: true });
    }

    disconnectedCallback() {
      window.removeEventListener('load', this.initBound);
      document.removeEventListener('shopify:block:select', this.blockSelectBound);
      this.swiper?.destroy(true, true);
      this.swiper = null;
    }

    handleBlockSelect(event) {
      const slide = event.target.closest('.d50-review-showcase__slide');
      if (!slide || !this.contains(slide) || !this.swiper) return;

      // 在主题编辑器选中评论区块时展示对应卡片。
      const index = [...this.querySelectorAll('.d50-review-showcase__slide')].indexOf(slide);
      if (index >= 0) this.swiper.slideTo(index, 0);
    }

    initSwiper() {
      if (!this.isConnected || this.swiper || !window.Swiper) return;

      const prevButton = this.querySelector('[data-review-prev]');
      const nextButton = this.querySelector('[data-review-next]');
      const pagination = this.querySelector('[data-review-pagination]');

      // 移动端显示下一张卡片的一部分；桌面端每次只展示一条评论。
      this.swiper = new window.Swiper(this.slider, {
        slidesPerView: 'auto',
        spaceBetween: 20,
        watchOverflow: true,
        grabCursor: true,
        observer: true,
        observeParents: true,
        navigation: {
          prevEl: prevButton,
          nextEl: nextButton,
        },
        pagination: {
          el: pagination,
          clickable: true,
        },
        keyboard: {
          enabled: true,
          onlyInViewport: true,
        },
        a11y: {
          enabled: true,
        },
        breakpoints: {
          769: {
            slidesPerView: 1,
            spaceBetween: 0,
          },
        },
      });
    }
  }

  customElements.define('d50-review-showcase', D50ReviewShowcase);
}
